export const state = {
    enabled: null,
    host: null,
    name: null,
    shareName: null
};

export const mutations = {};

export const getters = {};

export const actions = {};

export default {
    state,
    mutations,
    getters,
    actions
};
